module.exports = __webpack_public_path__ + "assets/img/gaoji.1b54fe04.png";